import { render } from "./FooterComp.vue?vue&type=template&id=bef09d82&scoped=true"
const script = {}

import "./FooterComp.vue?vue&type=style&index=0&id=bef09d82&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bef09d82"]])

export default __exports__